export const GlobalActions = {
  ON_RESIZE: "ON_RESIZE",
  ON_BANNER_OVER: "ON_BANNER_OVER",
}
